import React from 'react'
import { CustomerGroup } from '../../auth'
import { RouteRedirect } from '../../components/RouteRedirect'
import * as Pages from '../../pages'
import { NewRouteDefinition } from '../../routes'
import { Project, ProjectContext } from '../Project'

export function getConsoleRoutes(): NewRouteDefinition {
  return {
    path: '/',
    usage: 'simple',
    element: <RouteRedirect routePath="/console/project" />,
    routes: [
      {
        path: 'profile',
        usage: 'simple',
        element: <Pages.EditProfile />,
        displayName: 'User Profile',
        iconPath: '/images/user',
      },
      {
        path: 'account-users',
        usage: 'simple',
        element: <Pages.ManageAccountUsers />,
        displayName: 'Manage Account Users',
        requiredAuth: CustomerGroup.AccessAdmin,
        routes: [
          {
            path: 'account-users/add',
            usage: 'simple',
            element: <Pages.AddAccountUser />,
            displayName: 'Add Account User',
          },
          {
            path: 'account-users/:id',
            usage: 'simple',
            element: <Pages.UpdateAccountUser />,
            displayName: 'Edit Account User',
          },
        ],
      },
      {
        path: 'project',
        usage: 'simple',
        element: <RouteRedirect routePath="/console/project/:projectId" />,
        routes: [
          {
            path: 'project/:projectId/*',
            usage: 'simple',
            element: (
              <ProjectContext>
                <Project />
              </ProjectContext>
            ),
          },
        ],
      },
    ],
  }
}
